import React, { useState, useEffect, useMemo } from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LayoutDashboard from '../layout/LayoutDashboard';
import '../CSS/ListeDeclarations.css';
import apiUrl from '../config';
import { NovaSectionLoader } from './ui/NovaLoader';
import '../CSS/CraPages.css';

const ListeDeclarations = () => {

  const [salaries, setSalaries] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {

    const fetchSalaries = async () => {

      try{

        const token = localStorage.getItem('token');

        const response = await axios.get(
          `${apiUrl}/users-declarations`,
          { headers:{ Authorization:`Bearer ${token}` } }
        );

        setSalaries(response.data);

      }catch(error){
        console.error(error);
      }

      setLoading(false);

    };

    fetchSalaries();

  },[]);

  const handleNavigateToDeclarations = (id) => {
  localStorage.setItem("selectedUserId", id);
  navigate("/CRA", { state: { selectedUserId: id } }); // ✅ userId → selectedUserId
};

  
const listeDeclarationsStats = useMemo(() => {
  const rows = Array.isArray(salaries) ? salaries : [];

  const total = rows.length;

  const admins = rows.filter((row) =>
    String(row.role || row.type || '').toUpperCase() === 'ADMIN'
  ).length;

  const comptesValides = rows.filter((row) =>
    String(row.compte_status || row.status || '').toLowerCase().includes('valid')
  ).length;

  const comptesACompleter = rows.filter((row) =>
    String(row.compte_status || row.status || '').toLowerCase().includes('compl')
  ).length;

  const usersCount = Math.max(total - admins, 0);

  return {
    total,
    usersCount,
    admins,
    comptesValides,
    comptesACompleter
  };
}, [salaries]);

return (

<LayoutDashboard>

<div className="declarations-page">

{/* HEADER */}

<div className="header">

<Typography variant="h1">
Liste des CRA
</Typography>

</div>

{/* TABLE */}

<div className="declarations-table">

{loading ? (

<div className="loading">

<NovaSectionLoader label="Chargement des données" helper="Merci de patienter quelques secondes." />

</div>

) : (


<>
<section className="liste-declarations-stats-grid">
  <article className="liste-declarations-stat-card">
    <span>Total</span>
    <strong>{listeDeclarationsStats.total}</strong>
    <small>ressource(s)</small>
  </article>

  <article className="liste-declarations-stat-card">
    <span>Salariés</span>
    <strong>{listeDeclarationsStats.usersCount}</strong>
    <small>utilisateur(s)</small>
  </article>

  <article className="liste-declarations-stat-card">
    <span>Admins</span>
    <strong>{listeDeclarationsStats.admins}</strong>
    <small>administrateur(s)</small>
  </article>

  <article className="liste-declarations-stat-card">
    <span>Comptes validés</span>
    <strong>{listeDeclarationsStats.comptesValides}</strong>
    <small>accès actif(s)</small>
  </article>
</section>

<TableContainer>

<Table>

<TableHead>

<TableRow>

<TableCell>Nom</TableCell>
<TableCell>Prénom</TableCell>
<TableCell>Email</TableCell>
<TableCell>CRA</TableCell>
<TableCell>Statut</TableCell>
<TableCell>Action</TableCell>

</TableRow>

</TableHead>

<TableBody>

{salaries.map((salarie)=>(

<TableRow key={salarie.id}>

<TableCell>{salarie.nom}</TableCell>
<TableCell>{salarie.prenom}</TableCell>
<TableCell>{salarie.email}</TableCell>
<TableCell>{salarie.declarationsCount}</TableCell>

<TableCell>

<span className={
salarie.compte_status === "Compte validé"
? "status-ok"
: "status-bad"
}>

{salarie.compte_status}

</span>

</TableCell>

<TableCell>

<Button
className="action-btn"
onClick={()=>handleNavigateToDeclarations(salarie.id)}
>

Voir CRA

</Button>

</TableCell>

</TableRow>

))}

</TableBody>

</Table>

</TableContainer>
</>

)}

</div>

</div>

</LayoutDashboard>

);

};

export default ListeDeclarations;
